module.exports = __webpack_public_path__ + "components/flag/static/square/li-681f449fe8116d032949f95e71b25c70.svg";